module.exports = __webpack_public_path__ + "media/images/fallback/figures/search_thumbnail/default_article_image_3-b574a32a0f818431096c5d835e3b0392.png";